import { mix, observable } from "@chorda/core";
export const withPortal = (props) => {
    return mix({
        injections: {
            portal: () => observable(null)
        },
        templates: {
            portal: {
                css: 'portal-host',
                reactions: {
                    portal: (v) => ({ components: { content: v } })
                }
            },
            content: props
        }
    });
};
